<template>
    <div>
        <app-bar :title="t('workouts_title')"></app-bar>

        <v-layout>
            <workout-collection></workout-collection>
        </v-layout>
    </div>
</template>

<script lang="ts">
    import { defineComponent, reactive, toRefs } from '@vue/composition-api'
    import { useI18n } from 'vue-i18n-composable'
    import WorkoutCollection from '@/components/workouts/WorkoutCollection.vue'

    export default defineComponent({
        components: {
            WorkoutCollection,
        },

        /**
         * @param props
         */
        setup(props) {
            const state = reactive({})

            return {
                ...useI18n(),
                ...toRefs(state)
            }
        }
    })
</script>